export const DATE_INPUT_DROPDOWN_ID = 'date-input-date-picker-dropdown'
